export const ConfirmGroupStepController = [
    '$scope', '$location', '$q', '$window', 'RegistrationService',
    function($scope, $location, $q, $window, RegistrationService) {
        $scope.groupName = 'Last Step!';
        $scope.withHero = false; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 0; // the last step number of this group
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/confirm.html';

        $scope.userTitle = $scope.registrationData.constructTitle();
        $scope.doMatching = true;

        // this is just a shorthand reference
        $scope.goals = $scope.registrationData.CareerGoals;

        $scope.autoAdvance = true;

        $scope.customizedLastStepButtonText = 'Go to my dashboard';
        if ($scope.registrationSettings.WhitelabelSettings['customized:skipMatching'] &&
            $scope.registrationSettings.WhitelabelSettings['customized:lastStepText']) {
            $scope.doMatching = false;
            $scope.customizedLastStepButtonText = $scope.registrationSettings.WhitelabelSettings['customized:lastStepButtonText'] ?
                $scope.registrationSettings.WhitelabelSettings['customized:lastStepButtonText'] : $scope.customizedLastStepButtonText;
            $scope.customizedLastStepSystemSpeakText = $scope.registrationSettings.WhitelabelSettings['customized:lastStepText'];
            $scope.customizedLastStepAdditionalText = $scope.registrationSettings.WhitelabelSettings['customized:lastStepAdditionalText'];
        }

        $scope.goToMatching = function() {
            $q.when($scope.registrationData.save()).then(function() {
                if ($scope.doMatching) {
                    $location.path('/matching');
                } else {
                    RegistrationService.registrationComplete();
                }
            }, function() {
                // there was some error saving, need to figure out what is wrong and take us to that page
                // ideally, each page will check for validity before we allow them to go to next, but
                // should definitely keep a catchall here
            });
        };
    },
];
